module.exports = __webpack_public_path__ + "static/media/bntc.d2f69b36.png";